import { computed, onServerPrefetch } from 'vue'
import { useNoFilterCounters } from '../car/data/useNoFilterCounters'

export function useSuppliers() {
  const { data: noFilterMetadata, suspense } = useNoFilterCounters('auction')
  onServerPrefetch(suspense)

  const suppliers = computed(
    () => noFilterMetadata.value?.counters?.supplier ?? {},
  )

  return { suppliers }
}
